import { CONNECT_SERVICE_STEP_TEST_IDS } from "@bcc/components/onboarding/connect-service-step.utils";
import { setMapProductsStepTestId } from "@bcc/components/onboarding/map-products-step.utils";
import { ROUTE_PATHS } from "@bcc/lib/constants";
import type { SetupGuidePage, SetupGuideRegistry } from "../../tour.types";
import { testIdSelector } from "../../tour.utils";
import { setupConnectTour } from "./connect.tour";
import { setupMapTour } from "./map.tour";

export const SETUP_GUIDE_PAGES: readonly SetupGuidePage[] = ["connect", "map"];

/** One guide per onboarding page; kept out of `tourRegistry` and only offered on its own page */
export const setupGuideRegistry: SetupGuideRegistry = {
  connect: {
    route: ROUTE_PATHS.ONBOARDING,
    readySelector: testIdSelector(CONNECT_SERVICE_STEP_TEST_IDS.container),
    tour: setupConnectTour,
  },
  map: {
    route: ROUTE_PATHS.ONBOARDING_STEP_2,
    readySelector: testIdSelector(setMapProductsStepTestId("container")),
    tour: setupMapTour,
  },
};

/** The setup guide page for a pathname, or undefined off the onboarding pages */
export const resolveSetupGuidePage = (pathname: string, registry: SetupGuideRegistry = setupGuideRegistry): SetupGuidePage | undefined =>
  SETUP_GUIDE_PAGES.find((page) => registry[page].route === pathname);

export { ONBOARDING_ROUTE_PATTERNS, setupConnectTour } from "./connect.tour";
export { setupMapTour } from "./map.tour";
